import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "customCurrency",
})
export class CustomCurrencyPipe implements PipeTransform {
  transform(value: unknown, currency: string): unknown {
    return currency === "Soles" || currency === "S/" ? "S/ " + value : "US$ " + value;
  }
}
